import React from 'react';
import DialogComponent from '../dialog/dialog.component';
import { InfoIcon, CheckCircle2, Circle } from 'lucide-react';

interface WarningUpdateProfileProps {
  visible: boolean;
  onClose: () => void;
  profile: any;
}

// Các mục bắt buộc để hoàn thiện hồ sơ (khớp với form "Chỉnh sửa chi tiết").
const REQUIRED_FIELDS: {
  key: string;
  label: string;
  isFilled: (p: any) => boolean;
}[] = [
  { key: 'fullname', label: 'Họ và tên', isFilled: (p) => !!p?.fullname },
  { key: 'dob', label: 'Ngày sinh', isFilled: (p) => !!p?.dob },
  { key: 'sex', label: 'Giới tính', isFilled: (p) => !!p?.sex },
  {
    key: 'description',
    label: 'Giới thiệu bản thân',
    isFilled: (p) => !!p?.description,
  },
  {
    key: 'categoryFavorites',
    label: 'Sở thích',
    isFilled: (p) =>
      Array.isArray(p?.categoryFavorites)
        ? p.categoryFavorites.length > 0
        : !!p?.categoryFavorites,
  },
];

const WarningUpdateProfile = ({
  profile,
  visible,
  onClose,
}: WarningUpdateProfileProps) => {
  const checks = REQUIRED_FIELDS.map((f) => ({
    ...f,
    done: f.isFilled(profile),
  }));
  const missingCount = checks.filter((c) => !c.done).length;

  const handleComplete = () => {
    onClose();
    // Kết nối tới chỗ cần điền: mở sẵn modal "Chỉnh sửa chi tiết" đang render trên trang cá nhân.
    document.getElementById('edit-profile')?.click();
  };

  return (
    <DialogComponent
      visible={visible}
      onClose={onClose}
      title="Hoàn thiện trang cá nhân"
    >
      <div className="flex w-full max-w-[440px] flex-col gap-5 p-6">
        <div className="flex items-start gap-3">
          <div className="grid h-10 w-10 shrink-0 place-items-center rounded-full bg-amber-100 dark:bg-amber-500/15">
            <InfoIcon size={22} className="text-amber-500" />
          </div>
          <p className="text-sm leading-relaxed text-slate-600 dark:text-slate-300">
            {missingCount > 0 ? (
              <>
                Hồ sơ của bạn còn thiếu{' '}
                <b className="text-slate-800 dark:text-white">
                  {missingCount} mục
                </b>
                . Bổ sung các mục dưới đây để mở khoá đầy đủ tính năng.
              </>
            ) : (
              'Vui lòng rà soát lại thông tin hồ sơ để mở khoá đầy đủ tính năng.'
            )}
          </p>
        </div>

        <ul className="flex flex-col gap-2.5">
          {checks.map((c) => (
            <li key={c.key} className="flex items-center gap-2.5 text-sm">
              {c.done ? (
                <CheckCircle2 size={18} className="shrink-0 text-emerald-500" />
              ) : (
                <Circle size={18} className="shrink-0 text-slate-300 dark:text-slate-600" />
              )}
              <span
                className={
                  c.done
                    ? 'text-slate-400 line-through dark:text-slate-500'
                    : 'font-medium text-slate-700 dark:text-slate-200'
                }
              >
                {c.label}
              </span>
            </li>
          ))}
        </ul>

        <div className="flex items-center justify-end gap-3 pt-1">
          <button
            type="button"
            onClick={handleComplete}
            className="h-11 min-w-[148px] rounded-md bg-[#0057FF] px-4 text-sm font-semibold text-white transition hover:brightness-110 active:scale-[0.98]"
          >
            Hoàn thiện ngay
          </button>
        </div>
      </div>
    </DialogComponent>
  );
};

export default WarningUpdateProfile;
